module.exports = function() {
  return new Worker(__webpack_public_path__ + "29d176edfba4849af872.worker.js");
};